var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i18n',_vm._g(_vm._b({class:`text-${_vm.size} font-weight-${_vm.weight} text--${_vm.color}`,attrs:{"tag":_vm.tag}},'i18n',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }